import React, { useEffect, useState } from 'react';
import { Link as Anchor } from 'react-router-dom';
import Modal from 'react-modal';
import logo from '../../images/logo.png';
import facebookIcon from '../../images/social/facebook.webp';
import instagramIcon from '../../images/social/instagram.webp';
import whatsappIcon from '../../images/social/whatsapp.png';
import baseURL from '../url';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile';
import './Navbar.css';
import Favoritos from '../Favoritos/Favoritos';
import InputSerach from '../InputSerach/InputSearchs';
import CustomerAccount from '../CustomerAccount/CustomerAccount';
import Logout from '../Admin/Logout/Logout';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [usuario, setUsuario] = useState({});
    const [contactos, setContactos] = useState({});

    useEffect(() => {
        cargarBanners();
        cargarContacto();
        cargarUsuario();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const contacto = Array.isArray(data.contacto)
                    ? [...data.contacto].reverse()[0] || {}
                    : (data.contacto || {});
                setContactos(contacto);
            })
            .catch(error => console.error('Error al cargar contacto:', error));
    };

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const bannerImages = Array.isArray(data.banner)
                    ? data.banner.map(banner => banner.imagen).filter(Boolean)
                    : [];
                setImages(bannerImages);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar banners:', error);
                setLoading(false);
            });
    };

    const cargarUsuario = () => {
        fetch(`${baseURL}/userLogued.php`)
            .then(response => {
                if (!response.ok) return {};
                return response.json();
            })
            .then(data => setUsuario(data || {}))
            .catch(error => {
                console.error('Error al obtener datos:', error);
                setUsuario({});
            });
    };

    const whatsappDigits = String(contactos.whatsapp || contactos.telefono || '').replace(/[^0-9]/g, '');

    return (
        <header>
            <nav>
                <Anchor to="/" className="logo">
                    <img src={logo} alt="logo" />
                </Anchor>

                <div className="deFLexNavs">
                    <Favoritos />
                    <InputSerach />
                    <CustomerAccount />

                    <button
                        type="button"
                        aria-label="Abrir menú"
                        className={`nav_toggle ${isOpen ? 'open' : ''}`}
                        onClick={() => setIsOpen(true)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>

                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay"
                    ariaHideApp={false}
                >
                    <div className="modalNav-content">
                        {loading ? (
                            <div className="loadingBannerFondo"></div>
                        ) : (
                            <div>
                                {images[0] && (
                                    <div className="fondo">
                                        <img src={images[0]} alt="banner" />
                                    </div>
                                )}

                                <Profile />

                                <div className="navSocialOnly">
                                    <p>Síguenos y escríbenos directamente</p>
                                    <div className="navSocialIconLinks">
                                        {contactos.facebook && (
                                            <a className="socialIcon facebookIcon" href={contactos.facebook} target="_blank" rel="noreferrer" aria-label="Facebook">
                                                <img src={facebookIcon} alt="Facebook" />
                                            </a>
                                        )}

                                        {contactos.instagram && (
                                            <a className="socialIcon instagramIcon" href={contactos.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
                                                <img src={instagramIcon} alt="Instagram" />
                                            </a>
                                        )}

                                        {whatsappDigits && (
                                            <a className="socialIcon whatsappIcon" href={`https://wa.me/${whatsappDigits}`} target="_blank" rel="noreferrer" aria-label="WhatsApp">
                                                <img src={whatsappIcon} alt="WhatsApp" />
                                            </a>
                                        )}
                                    </div>
                                </div>

                                {usuario.idUsuario ? <Logout /> : null}
                            </div>
                        )}
                    </div>
                </Modal>
            </nav>
        </header>
    );
}
